import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiTarget, FiArrowRight } = FiIcons;

const QuizTypeSelector = ({ onSelect, targetType }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8, duration: 0.6 }}
      className="mb-8"
    >
      <h3 className="text-2xl font-semibold text-brand-coffee mb-6 text-center font-luxe">
        Choose Your Assessment Type
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        
        <motion.button
          whileHover={{ scale: 1.02, y: -5 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onSelect('focused', targetType)}
          className="p-6 bg-brand-floral rounded-2xl shadow-lg border-2 border-brand-dust hover:border-brand-golden transition-all duration-300 text-left group"
        >
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-brand-golden rounded-full flex items-center justify-center mr-4">
              <SafeIcon icon={FiClock} className="text-brand-floral text-xl" />
            </div>
            <div>
              <h4 className="text-xl font-bold text-brand-coffee font-luxe">Focused Snapshot</h4>
              <p className="text-sm text-brand-coffee/70">Quick overview • 5-7 minutes</p>
            </div>
          </div>
          <p className="text-brand-coffee/80 mb-4">
            Get immediate insights with our streamlined assessment. Perfect for a quick overview of your brain profile.
          </p>
          <div className="flex items-center text-brand-golden group-hover:text-brand-coffee transition-colors">
            <span className="font-semibold">Start Quick Assessment</span>
            <SafeIcon icon={FiArrowRight} className="ml-2" />
          </div>
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.02, y: -5 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onSelect('comprehensive', targetType)}
          className="p-6 bg-brand-floral rounded-2xl shadow-lg border-2 border-brand-dust hover:border-brand-crimson transition-all duration-300 text-left group relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 bg-brand-crimson text-brand-floral px-3 py-1 text-xs font-bold rounded-bl-lg">
            RECOMMENDED
          </div>
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-brand-crimson rounded-full flex items-center justify-center mr-4">
              <SafeIcon icon={FiTarget} className="text-brand-floral text-xl" />
            </div>
            <div>
              <h4 className="text-xl font-bold text-brand-coffee font-luxe">Comprehensive Map</h4>
              <p className="text-sm text-brand-coffee/70">In-depth analysis • 10-15 minutes</p>
            </div>
          </div>
          <p className="text-brand-coffee/80 mb-4">
            Our most detailed assessment providing comprehensive insights across all cognitive domains. Best for thorough self-understanding.
          </p>
          <div className="flex items-center text-brand-crimson group-hover:text-brand-midnight transition-colors">
            <span className="font-semibold">Start Comprehensive Assessment</span>
            <SafeIcon icon={FiArrowRight} className="ml-2" />
          </div>
        </motion.button>

      </div>
    </motion.div>
  );
};

export default QuizTypeSelector;